// import http from "../http-common";
import api from './api';

//https://www.bezkoder.com/react-hooks-file-upload/

const upload = (file, currentUser, uid, empDocType, onUploadProgress) => {
  let formData = new FormData();

  // const mystring = 'XYZ';

  //gg: react upload with parameter
  formData.append('file', file);
  formData.append('data1', currentUser);
  formData.append('data2', empDocType);
  formData.append('data3', uid);

  return api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

const uploadSignPad = (
  file,
  currentUser,
  uid,
  empDocType,
  onUploadProgress
) => {
  let formData = new FormData();

  // const mystring = 'XYZ';

  //gg: react upload with parameter
  formData.append('file', file);
  formData.append('data1', currentUser);
  formData.append('data2', empDocType);
  formData.append('data3', uid);

  return api.post('/signpadupload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

const getFiles = () => {
  return api.get('/files');
};

const getFile = (id) => {
  return api.get(`/file/${id}`);
};

const getFileInfo = (id) => {
  return api.get(`/file-info/${id}`);
};

const getFileInfo2 = (username) => {
  return api.get(`/file-info2/${username}`);
};

const removeBg = (file, currentUser, uid, empDocType, onUploadProgress) => {
  let formData = new FormData();
  formData.append('file', file);
  formData.append('data1', currentUser);
  formData.append('data2', empDocType);
  formData.append('data3', uid);

  return api.post('/signupload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

const uploadPw = (filenames, currentUser, uid) => {
  let formData = new FormData();

  // const mystring = 'XYZ';

  //gg: react upload with parameter
  formData.append('filenames', filenames);
  formData.append('data1', currentUser);
  // formData.append('data2', empDocType);
  formData.append('data3', uid);

  return api.post('/upload-pw', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    // onUploadProgress,
  });
};

export default {
  upload,
  getFile,
  getFiles,
  getFileInfo,
  getFileInfo2,
  removeBg,
  uploadSignPad,
  uploadPw,
};
